import { ls } from "@/utils/cache";
import { USERINFO, TOKEN, SYSTEMPARAM } from "@/store/mutation-types";
import { routeTo, routeReplace } from "@/utils/common";
import authApi from "@/api/auth";
import * as dd from "dingtalk-jsapi";

const user = {
  namespaced: true,
  state: {
    token: "",
    userInfo: {},
    messageCount: 0,
    systemParam: {}, //系统参数
  },
  mutations: {
    SET_TOKEN: (state, data) => {
      state.token = data;
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data;
    },
    SET_MESSAGECOUNT: (state, count) => {
      state.messageCount = count;
    },
    SET_SYSTEMPARAM: (state, systemParam) => {
      state.systemParam = systemParam;
    },
  },
  actions: {
    setToken({ commit }, data) {
      ls.set(TOKEN, data);
      commit("SET_TOKEN", data);
    },
    setUserInfo({ commit }, data) {
      ls.set(USERINFO, data);
      commit("SET_USERINFO", data);
    },
    setMessageCount({ commit }, data) {
      commit("SET_MESSAGECOUNT", data);
    },
    logout({ commit }) {
      this.dispatch("app/setPageKeepAlive", []);
      commit("SET_TOKEN", "");
      commit("SET_USERINFO", {});
      ls.remove(TOKEN);
      ls.remove(USERINFO);
      routeTo({
        name: "Login",
        query: {
          isLoginOut: true,
        },
      });
    },
    login({ commit }) {
      return new Promise((resolve, reject) => {
        function sendLogin(code) {
          authApi
            .Login({
              code,
            })
            .then((loginRes) => {
              const token = "Bearer " + loginRes.Data.AccessToken;
              ls.set(TOKEN, token);
              commit("SET_TOKEN", token);
              ls.set(USERINFO, loginRes.Data);
              commit("SET_USERINFO", loginRes.Data);
              resolve(loginRes);
            })
            .catch((err) => {
              reject(err);
            });
        }
        //测试环境
        if (process.env.NODE_ENV === "development") {
          sendLogin("fake_060165623824446226");
          return;
        }

        //正式环境打开
        authApi.GetCorpId({}).then((res) => {
          if (dd.env.platform === "notInDingTalk") {
            routeReplace({
              path: "/notInDingTalk",
            });
          } else {
            dd.runtime.permission.requestAuthCode({
              corpId: res.Data.CorpId,

              onSuccess: function(ddRes) {
                // 调用成功时回调
                sendLogin(ddRes.code);
              },
              onFail: function(err) {
                // 调用失败时回调
                alert(123);
                console.error(err);
              },
            });
          }
        });
      });
    },
  },
};

export default user;
